import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  FormFieldConfig,
  ProviderClass,
  WidgetLayoutAttributes,
} from '@finxone-platform/shared/sys-config-types';
import { BeneficiaryFormService } from '../beneficiary-form.service';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-beneficiary-type-widget',
  templateUrl: './beneficiary-type-widget.component.html',
})
export class BeneficiaryTypeWidgetComponent implements OnInit {
  public inputFieldConfig: FormFieldConfig;
  public validationConfig: { type: string; message: string }[] = [];

  public formControlName = 'type';
  public beneficiaryForm: FormGroup;
  public inputLabel: string;

  constructor(
    public dataIn: ProviderClass<WidgetLayoutAttributes>,
    private beneficiaryFormService: BeneficiaryFormService,
  ) {}

  public ngOnInit(): void {
    this.setWidgetConfig();
  }

  private setWidgetConfig() {
    if (this.dataIn != undefined && this.dataIn.attri?.widgetProperties?.inputFieldConfig) {
      this.inputFieldConfig = this.dataIn.attri?.widgetProperties?.inputFieldConfig;
      this.inputLabel = this.dataIn.attri?.widgetProperties?.inputLabel || '';

      this.beneficiaryForm = this.beneficiaryFormService.beneficiaryForm;
      this.validationConfig = this.beneficiaryFormService.getValidationConfig(
        this.inputFieldConfig.validation,
      );
    }
  }

  public get selectedOptionLabel(): string {
    const value = this.beneficiaryForm.controls[this.formControlName]?.value;
    const selected = this.inputFieldConfig.options?.find((option) => option?.value === value);
    return selected?.label ?? '';
  }
}
